import {attr, Collection, define, Record} from "type-r";

@define
class TokenModel extends Record {
    @attr token: string;
    @attr username?: string;
    @attr comment?: string;
    @attr isCurrent: boolean;

    static collection = {
        getCurrent(): TokenModel{
            const currentTokens = this.filter((token:TokenModel)=>token.isCurrent);
            if(currentTokens.length){
                return currentTokens[0]
            }
            return null;
        }
    }
}
interface TokenCollection extends Collection<TokenModel> {
    getCurrent: () => TokenModel
}
export {TokenCollection};
export default TokenModel;


// WEBPACK FOOTER //
// ./src/models/TokenModel.ts